import { Box } from '@chronosphereio/chrono-ui';
import { ContentDimensions } from '@/core';
import { ContentWithLegendCollapse, ContentWithLegendCollapseProps } from './ContentWithLegendCollapse';
import { ContentWithLegendGroupBy, ContentWithLegendGroupByProps } from './ContentWithLegendGroupBy';
import { ContentWithLegendQuickFilter } from './ContentWithLegendQuickFilter';
import { ContentWithLegendToggleMode } from './ContentWithLegendToggleMode';
import { ContentWithLegendQuickFilterProps, ContentWithLegendToggleModeProps } from './model/content-with-legend-model';

export interface ContentWithLegendToolbarProps extends ContentDimensions {
  quickFilterProps?: ContentWithLegendQuickFilterProps;
  toggleModeProps?: ContentWithLegendToggleModeProps;
  collapsibleLegendProps?: ContentWithLegendCollapseProps;
  groupByProps?: ContentWithLegendGroupByProps;
}

export function ContentWithLegendToolbar({
  width,
  height,
  quickFilterProps,
  toggleModeProps,
  collapsibleLegendProps,
  groupByProps,
}: ContentWithLegendToolbarProps) {
  return (
    <Box
      sx={{ width, height, display: 'flex', alignItems: 'center', paddingX: 0.5, gap: (theme) => theme.spacing(1.5) }}
    >
      {collapsibleLegendProps?.show && <ContentWithLegendCollapse {...collapsibleLegendProps} />}
      {quickFilterProps?.show && <ContentWithLegendQuickFilter {...quickFilterProps} />}
      {groupByProps?.show && <ContentWithLegendGroupBy {...groupByProps} />}
      {toggleModeProps?.show && !collapsibleLegendProps?.isCollapsed && (
        <ContentWithLegendToggleMode {...toggleModeProps} />
      )}
    </Box>
  );
}
